module.exports = __webpack_public_path__ + "static/media/Githubicon.6f59b69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Githubicon.png
// module id = 6
// module chunks = 0